import { safeInt } from '../safeInt';

export const setIdTipoFacturacion = (data) => {
    let idTipoFacturacion = 1;
    if (data.tipoFacturacion != null && typeof data.tipoFacturacion === "object" && data.tipoFacturacion.codigo != null) {
        idTipoFacturacion = safeInt(data.tipoFacturacion.codigo, 1);
    } else if (data.tipoFacturacion != null && typeof data.tipoFacturacion !== "object") {
        idTipoFacturacion = safeInt(data.tipoFacturacion, 1);
    }

    return idTipoFacturacion;
}